/**
 * Created by zxh on 2016/12/26.
 */

export default {
    LOADING({commit}, bool) {   // 更新载入界面状态
        commit('LOADING', bool);
    },
    NET_ERROR({commit}, bool) {     // 设置网络状态
        commit('NET_ERROR', bool);
    },
    // 设置将vuex的对象(localStorage和sessionStorage)存储或者取出
    // @param bool : true: 将local和session里的对象取出到vuex中
    //               false: 将vuex中的对象存储起来
    RECOVERY_TO_VUEX_UNIONLOGIN({commit}, bool) {
        commit('RECOVERY_TO_VUEX_UNIONLOGIN', bool);
    }
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js